import account from "./TH/account.json"
import aiDiagnose from "./TH/aiDiagnose.json"
import allCarManage from "./TH/allCarManage.json"
import base from "./TH/base.json"
import bookingManagement from "./TH/bookingManagement.json"
import common from "./TH/common.json"
import contractManagement from "./TH/contractManagement.json"
import dataManage from "./TH/dataManage.json"
import home from "./TH/home.json"
import homeMap from "./TH/homeMap.json"
import moveCarManage from "./TH/moveCarManage.json"
import orderManage from "./TH/orderManage.json"
import ordersManage from "./TH/ordersManage.json"
import index from "./TH/index.json"
import menu from "./TH/menu.json"
import newCommon from "./TH/newCommon.json"
import paper from "./TH/paper.json"
import shopOrder from "./TH/shopOrder.json"
import statistics from "./TH/statistics.json"
import statisticsIndex from "./TH/statisticsIndex.json"
import storeManagement from "./TH/storeManagement.json"
import tdms from "./TH/tdms.json"
import teamManage from "./TH/teamManage.json"
import stock from "./TH/stock.json"
import settings from "./TH/settings.json"
import purchase from "./TH/purchase.json"
import shopping from "./TH/shopping.json"
import sale from "./TH/sale.json"
import quickBilling from "./TH/quickBilling.json"
import components from "./TH/components.json"
import erpcomponents from "./TH/erpcomponents.json"
import orgManage from "./TH/orgManage.json"
import customerManage from "./TH/customerManage.json"
import dataDictionaries from "./TH/dataDictionaries.json"
import login from "./TH/Login.json"
import logs from "./TH/logs.json"
import permission from "./TH/permission.json"




const thTH = {
  translation: {
    permission,
    logs,
    login,
    common,
    index,
    menu,
    aiDiagnose,
    bookingManagement,
    allCarManage,
    contractManagement,
    dataManage,
    home,
    homeMap,
    moveCarManage,
    orderManage,
    ordersManage,
    teamManage,
    tdms,
    storeManagement,
    statisticsIndex,
    statistics,
    shopOrder,
    account,
    base,
    paper,
    newCommon,
    stock,
    settings,
    purchase,
    shopping,
    sale,
    quickBilling,
    components,
    erpcomponents,
    orgManage,
    customerManage,
    dataDictionaries
  }
};
export default thTH;
